import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Button, Divider, notification, Space, Typography } from 'antd'

import ChannelSelect from '../../../helpers/ChannelSelect/ChannelSelect'
import SpinLoader from '../../../helpers/SpinLoader'

import { getChannels, getUser, upgradeUser } from '../../../../context/admin/utils'
import { Brand, Channel, User } from '../../../../context/types'

const { Title, Paragraph } = Typography

interface UrlParam {
	id: string
}

function UpgradeUser() {
	const { id } = useParams() as UrlParam
	const history = useHistory()

	const [user, setUser] = useState<User>()
	const [channels, setChannels] = useState<Channel[]>([])
	const [brands, setBrands] = useState<Brand[]>([])

	const [loading, setLoading] = useState(false)

	const [selectedChannel, setSelectedChannel] = useState<Channel>()

	useEffect(() => {
		setLoading(true)
		getUser(parseInt(id, 10))
			.then((r) => setUser(r.user))
			.catch(handleError)
			.finally(() => setLoading(false))
	}, [id])

	useEffect(() => {
		getChannels()
			.then((r) => {
				setChannels(r.channels)
				setBrands(r.brands)
			})
			.catch(handleError)
	}, [])

	const handleError = (err: any) => {
		notification.error({ message: err.message || 'Error' })
	}

	const handleCancel = () => {
		history.go(-1)
	}

	const handleSubmit = () => {
		setLoading(true)
		upgradeUser(user.id, selectedChannel?.id)
			.then(() => {
				notification.success({
					message: 'Success',
					description: 'User invited to become an expert',
				})
				history.go(-1)
			})
			.catch(handleError)
			.finally(() => setLoading(false))
	}

	if (!user) return <></>

	return (
		<SpinLoader loading={loading}>
			<Title level={3}>
				Upgrade {user.first_name} {user.last_name}
			</Title>

			<Divider style={{ borderColor: '#96C6E4' }} />

			<Space direction="vertical" size="large" style={{ minHeight: 500 }}>
				<Paragraph>
					<b>Invite As Expert To</b>
				</Paragraph>

				<ChannelSelect channels={channels} brands={brands} onChange={setSelectedChannel} />

				<Divider />

				<Space>
					<Button danger onClick={handleCancel}>
						Cancel
					</Button>
					<Button onClick={handleSubmit} disabled={!selectedChannel}>
						Submit
					</Button>
				</Space>
			</Space>
		</SpinLoader>
	)
}

export default UpgradeUser
